/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/Contracts" />
export enum StoreLoadingState {
    Loading = 0,
    Loaded,
    LoadFailed
}

export enum UpdatingState {
    InProgress,
    Succeeded,
    Failed,
    NotUpdating
}
